<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel-left">
                        <h2>Cancelar Marcação</h2>
                    </div>
                </div>
            </div>

            <div>
                <form [formGroup]="formularioCancelamento" (ngSubmit)="onSubmit()"
                    (keydown.enter)="$event.preventDefault()">
                    <div class="form-group">
                        <mat-divider fxFlex="1 0"></mat-divider>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-12 col-md-12 col-sm-12 col-12">
                            <mat-label>Motivo do Cancelamento</mat-label>
                            <mat-select value="Motivo do Cancelamento" formControlName="motivoCancelamento"
                                name="motivoCancelamento" id="motivoCancelamento" required>
                                <mat-option *ngFor="let motivoCancelamento of listaMotivoCancelamento"
                                    [value]="motivoCancelamento">
                                    {{motivoCancelamento.descricao}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="formularioCancelamento.controls.motivoCancelamento.hasError('required')">
                                O campo Motivo do Cancelamento é obrigatório.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <mat-form-field style="margin-top: 6.5px;"
                            class="form-group col-lg-12 col-md-12 col-sm-12 col-12">
                            <mat-label>Obs. Motivo do Cancelamento</mat-label>
                            <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                cdkAutosizeMinRows="2" cdkAutosizeMaxRows="3" formControlName="obsMotivoCancelamento"
                                name="obsMotivoCancelamento" id="obsMotivoCancelamento" maxlength="60"
                                upperCase></textarea>
                            <mat-error
                                *ngIf="formularioCancelamento.controls.obsMotivoCancelamento.hasError('required')">
                                O campo Obs. Motivo do Cancelamento é obrigatório.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="menu-formulario">
                        <div class="menu-formulario-botoes margin-right-10">
                            <button mat-mini-fab color="success" type="submit" matTooltip="Salvar"
                                [disabled]="!formularioCancelamento.valid">
                                <mat-icon>save</mat-icon>
                            </button>
                        </div>
                        <div class="menu-formulario-botoes">
                            <button type="button" mat-mini-fab color="primary" (click)="gotoList()" matTooltip="Voltar">
                                <mat-icon>west</mat-icon>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>